import store from "../../index.js";
import api from "../../../utils/api";
import UserConstant from '../../../mixins/user/const/userConstant.js';
import UserAcConstant from '../../../mixins/user/const/userAcConstant.js';

export const modules = {
    store,
};

export const state = {
    _error: {code:0, message:''},   
};

export const mutations = {  
    [UserConstant.ADD_AGREEMENT_ERROR]: (state, payload) => {
        state._error = {code:0, message:''};
        state._error = payload;
    },
};

export const actions = {
    async acUserAgreement({ commit }, payload) {
        const url = UserAcConstant.GET_AGREEMENT_USER;
        try {
            const res = await api.get(url, {
                params: {
                    terms_code: payload
                }
            });
            return res?.data?.code === 0 && res?.data?.data?.agreeYn;
        } 
        catch(error) {
            commit(UserConstant.ADD_AGREEMENT_ERROR, error.response.data);
            return false;
        }
    },
    async acAddUserAgreement({ commit }, payload) {
        const url = UserAcConstant.POST_AGREEMENT_USER;
        try {
            const res = await api.post(url, {
                terms_code: payload
            });
            return res?.data?.code === 0;
        } 
        catch(error) {
            commit(UserConstant.ADD_AGREEMENT_ERROR, error.response.data);
            return false;
        }
    },
};

export const getters = {
    geCodeFail: state => {
        switch(state._error.code){
            case 1008: return '약관코드가 존재 하지 않습니다.';
        }    
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};